import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppFields, Store, StorageUtil, AppTypes } from '../../../store';
import { MyTeamsService, AlertService } from '../../../services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CollegeRecrutingCenterService } from '../../../services/college-recruiting-center.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-subscription-fly-out',
  templateUrl: './subscription-fly-out.component.html',
  styleUrls: ['./subscription-fly-out.component.css']
})
export class SubscriptionFlyOutComponent implements OnInit {
  @Input() isTeamAccount: boolean = false;

  @Input() isEmailCampaign: boolean = false;
  @Input() hasLimitExceeded: boolean = false;

  @Input() isMobileApp: boolean = false;

  @Input() firstTabLable: string = "Info";
  @Input() clubDetails: any;
  @Input() subscriptionPlans: any;
  @Input() planList = [];
  @Input() productTypeID;

  @Input() title: string;
  @Input() subTitle: string;
  @Input() width: string;
  @Input() noPadding: boolean;
  @Input() tabs = [];
  @Input() selectedTab = 0;

  @Output() close: EventEmitter<Event> = new EventEmitter();
  @Output() getClubSubscriptionPlans: EventEmitter<void> = new EventEmitter();
  @Output() tabChange: EventEmitter<number> = new EventEmitter();
  @ViewChild('cardElement') cardElement: ElementRef;
  public isProgramSelected = false;
  public isCancelClicked = false;
  public isPlanAlreadyCancelled = false;
  public hasPlan = false;
  public codeApplied: boolean = false;
  public isAddNewCard = false;
  public isSelectedRepresentativeOther: boolean = false;
  public agreedToTerms: boolean = false;
  public isSelectedOtherOther: boolean = false;
  public isShowCollegeTransactionHistory = false;
  public addedLearnAboutProduct: boolean = false;
  public isShowCollegeInfo = true;
  public cardListCounts = 0;
  public userCardID: any;
  public card: any;
  public error: string;
  userDetails: any = [];
  public tokenData: any;
  public isDefaultCard: number;
  public CardDetail = [];
  public showAddNewCardButton = false;
  public selectedCardData: any;
  public selectedProgram: any;
  public discountAmount: number = 0;
  public totalAmount: number = 0;
  public cardList: any[];
  public formCode: FormGroup;
  public cardHandler = this.onChange.bind(this);
  public selectedFeedbackOpton: string = "";
  public selectedResUserID = 0;
  public selectedResEmail: string = "";
  showTermsInModalOpened = false;
  public selectedRepresentativeName: string = null;
  public selectedClubName: string = null;
  public selectedClubRepresentativeName: string = null;
  public ipAddress: string;
  public paymentHistoryList = [];
  public paymentHistoryCounts = 0;
  isSelectOptionClicked = false;
  tgsRepresentativesOptions: any[] = [];

  public programFeedbackOptions = [
    {
      id: 1,
      title: 'TGS Rep',
      value: 'tgs'
    },
    {
      id: 2,
      title: 'Another Club',
      value: 'club'
    },
    {
      id: 3,
      title: 'Other',
      value: 'other'
    },
  ];
  public otherOptions = [
    {
      id: 'TGS Website',
      value: 'TGS Website'
    },
    {
      id: 'Email Campaign',
      value: 'Email Campaign'
    },
    {
      id: 'Social Media',
      value: 'Social Media'
    },
    {
      id: 'Other',
      value: 'Other'
    },
  ];

  isChange: boolean;

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    public _myTeamsService: MyTeamsService,
    private loader: Ng4LoadingSpinnerService,
    private cd: ChangeDetectorRef,
    private _service: CollegeRecrutingCenterService,
    private _alertService: AlertService,
    private router: Router,
  ) {

    this.store.select(AppFields.App, AppFields.User).subscribe((user) => {
      if (user != null) {
        this.userDetails = user;
      }
    });

  }

  onIsChange() {
    this.isCancelClicked = false;
    this.isChange = true;
  }

  collegeTransactionHistoryTab() {
    this.loader.show();
    let obj = {
      teamID: +StorageUtil.teamId,
      clubID: +StorageUtil.clubID,
      productTypeID: this.productTypeID
    }
    this._service.getSubscriptionTransactionHistory(obj).subscribe((x) => {
      this.paymentHistoryList = x;
      this.paymentHistoryCounts = this.paymentHistoryList.length;
      this.isShowCollegeTransactionHistory = true;
      this.loader.hide();

    }, (error) => {
      //  console.log(error.error);
      this.loader.hide();
      this._alertService.error("Something went wrong. Please try again.");
    });
    this.isShowCollegeInfo = false;
  }

  collegeInfoTab() {
    this.isShowCollegeInfo = true;
    this.isShowCollegeTransactionHistory = false;
  }

  ngOnInit() {

    // console.log("clubPlans =>", this.subscriptionPlans)
    if (this.subscriptionPlans != null) {
      //this.clubPlans = rs;
      this.hasPlan = this.subscriptionPlans.HasPlan;
      //this.isEvaluationActivated = this.clubPlans.isClubHasEvaluationPlan;
      this.isPlanAlreadyCancelled = this.subscriptionPlans.HasPlanCancelled;
    }
    this.initForm();
    this.getIP();
    this.getCardListByUserID();

    if (this.isTeamAccount) {
      if (!this.card) {
        this.card = elements.create('card');
        this.card.addEventListener('change', this.cardHandler);
      }
      this.onPlanSelected(this.planList[0]);
    }
    if (!this.isProgramSelected) {
      //this.getCardDetailsByStripeSubscriptionID();
    }

    this.getTGSRepresentativeList();
  }

  ngAfterViewInit() {
    /*Card*/
    if (!this.card) {
      this.card = elements.create('card');
      this.card.addEventListener('change', this.cardHandler);
    }
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.onChange);
    this.card.destroy();
  }

  initForm() {
    this.formCode = this.fb.group({
      Code: ['', [Validators.required]]
    });
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  closeSideOverlay(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close.emit(event);
  }

  onLearnAboutProdcut() {
    if (this.selectedFeedbackOpton == 'tgs') { //If Option is TGS
      if (this.isSelectedRepresentativeOther) { //If Options is Others Selected
        if (!this.selectedRepresentativeName) { //If not filled text box
          this.addedLearnAboutProduct = false;
        } else {
          this.addedLearnAboutProduct = true;
        }
      }
      else {
        if (this.selectedResUserID == 0) { //If not filled text box
          this.addedLearnAboutProduct = false;
        } else {
          this.addedLearnAboutProduct = true;
        }
      }
    }
    else if (this.selectedFeedbackOpton == 'club') {
      if (!this.selectedClubName || !this.selectedClubRepresentativeName) { //If not filled text box
        this.addedLearnAboutProduct = false;
      } else {
        this.addedLearnAboutProduct = true;
      }
    }
    else if (this.selectedFeedbackOpton == 'other') {
      if (this.isSelectedOtherOther) {
        if (!this.selectedRepresentativeName) { //If not filled text box
          this.addedLearnAboutProduct = false;
        } else {
          this.addedLearnAboutProduct = true;
        }
      }
      else {
        if (!this.selectedRepresentativeName) { //If not filled text box
          this.addedLearnAboutProduct = false;
        } else {
          this.addedLearnAboutProduct = true;
        }
      }
    }
    else {
      this.addedLearnAboutProduct = false;
    }
  }

  get valid(): boolean {
    this.onLearnAboutProdcut();
    //console.log('-----------------');
    //console.log('this.agreedToTerms =>', this.agreedToTerms);
    //console.log('this.addedLearnAboutProduct =>', this.addedLearnAboutProduct);
    //console.log('this.isAddNewCard =>', this.isAddNewCard);
    if (!this.agreedToTerms || !this.addedLearnAboutProduct || this.isAddNewCard || this.isSelectOptionClicked) {
      return false;
    }
    return true;
  }

  onPlanSelected(plan) {
    this.selectedProgram = plan;
    this.totalAmount = this.selectedProgram.price;
    this.isProgramSelected = true;
    if (this.cardListCounts == 0) {
      this.initCardNativeElement();
    }

  }

  switchTab(tab: number) {
    this.selectedTab = tab;
    this.tabChange.emit(tab);
  }

  onFeedbackOptionsChange(value) {
    this.selectedFeedbackOpton = value;
    this.isSelectedRepresentativeOther = false;
  }

  addNewCardRadioSelected(event) {
    this.showAddNewCardButton = false;
    if (event.target.checked === true) {
      this.initCardNativeElement();
    } else {
      this.isAddNewCard = false;
    }
  }

  onAgreeTerms(event) {
    if (event.target.checked === true) {
      this.agreedToTerms = true;
    } else {
      this.agreedToTerms = false;
    }
  }

  onOtherSelected(event) {
    this.isSelectedOtherOther = event.target.value === 'Other';
    if (!this.isSelectedOtherOther && event.target.value != 'Select an option') {
      this.selectedRepresentativeName = event.target.value;
    }
    else {
      this.selectedRepresentativeName = null;
    }
    //console.log("this.selectedRepresentativeName =>", this.selectedRepresentativeName);
  }

  onRepresentativeSelected(event) {
    if (event.target.value == -1) {
      this.isSelectedRepresentativeOther = true;
      this.isSelectOptionClicked = false;
      this.selectedRepresentativeName = null;
    }
    else if (event.target.value > 0) {
      this.isSelectedRepresentativeOther = false;
      this.isSelectOptionClicked = false;
      var rep = this.tgsRepresentativesOptions.find(x => x.userID == event.target.value);
      this.selectedResUserID = rep.userID;
      this.selectedResEmail = rep.email;
    }
    else if (event.target.value == 0) {
      this.isSelectedRepresentativeOther = false;
      this.isSelectOptionClicked = true;
    }
    // this.isSelectedRepresentativeOther = event.target.value === 'Other';
    // if (!this.isSelectedRepresentativeOther && event.target.value != 'Select an option') {
    //   this.selectedRepresentativeName = event.target.value;
    // }
    // else {
    //   this.selectedRepresentativeName = null;
    // }
  }

  cardNativeElement() {
    if (this.card) {
      setTimeout(() => {
        if (this.cardElement) {
          this.card.mount(this.cardElement.nativeElement);
        }
      }, 1000);
    }
  }

  isPreDefineCardSelect(card) {
    this.CardDetail.length = 0;
    this.CardDetail.push(card);
    this.selectedCardData = card;
    this.userCardID = this.CardDetail[0].userCardID;
    this.isDefaultCard = card.isDefault;
    this.isAddNewCard = false;
    this.error = '';
  }

  onCardSubmit() {
    let obj = {
      ClubID: StorageUtil.clubID,
      ProducttypeID: this.productTypeID,
      StripeSubscriptionID: this.subscriptionPlans.StripeSubscriptionID,
      UserCardID: this.userCardID,
    }
    this.loader.show();
    this._service.updateCardDetailsByStripeSubscriptionID(obj).subscribe((rs: any) => {
      this.loader.hide()
      this._alertService.success('Card Updated successfully.');
      this.closeSideOverlay();
    });
  }

  getIP() {
    this._myTeamsService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
      //console.log(this.ipAddress);
    });
  }

  showTermsInModal() {
    this.showTermsInModalOpened = true;
  }

  onCancelPlan() {
    this.isCancelClicked = true;
    this.isChange = false;
  }

  getCardListByUserID() {
    this._myTeamsService.getCardListByUserID(StorageUtil.userID).subscribe((cards: any) => {
      if (cards != null && cards.length > 0) {
        for (let i = 0; i < cards.length; i++) {
          const No = cards[i].maskedCCNum.split('-');
          cards[i].Lastfour = No[3];
          if (cards[i].isDefault === 1) {
            this.selectedCardData = cards[i];
            this.userCardID = cards[i].userCardID;
          }
        }
        this.cardList = cards;
        this.cardListCounts = cards.length;
        this.isAddNewCard = false;
      }
    });
  }
  cardId: number;
  confirmOpened: boolean = false;
  onCardRemove(cardId) {
    this.cardId = cardId;
    this.confirmOpened = true
  }
  onConfirmDelete() {
    this.loader.show();
    this._myTeamsService.deleteCard(StorageUtil.userID, this.cardId).subscribe(() => {
      this.loader.hide();
      this._alertService.success('Card removed successfully.');
      this.confirmOpened = false;
      this.getCardListByUserID();
    }, (error) => {
      console.log(error.error);
      if (error && error.error.includes('To remove this card')) {
        this._alertService.errorHigh(error.error);
      }
      else {
        this._alertService.error('Card can not be removed. Please try again.');
      }
      this.loader.hide();
    });
  }
  onCancelPlanBtnClick(isCancel) {
    this.loader.show();

    var obj = {
      SubscriptionID: this.subscriptionPlans.StripeSubscriptionID,
      ClubID: +StorageUtil.clubID,
      TeamID: +StorageUtil.teamId,
      isCancelSubscription: isCancel
    };

    this._service.cancelOrRenewSusbscriptionPlan(obj).subscribe(() => {
      if (isCancel)
        this._alertService.success("Current Plan is cancelled, but is still available until the end of your billing period.");
      else
        this._alertService.success("Current Plan is renewed.");

      this.onGoBackCancel();
      // this.getClubSubscriptionPlans();
      this.getClubSubscriptionPlans.emit();
      this.close.emit();
      this.loader.hide();
    }, (error) => {
      //console.log(error.error);
      this.loader.hide();
      this._alertService.error("Something went wrong. Please try again.");
    });
  }

  onGoBackCancel() {
    this.isCancelClicked = false;
  }

  cardText: string;
  getCardDetailsByStripeSubscriptionID() {
    this.loader.show();
    this._service.getCardDetailsByStripeSubscriptionID(this.subscriptionPlans.StripeSubscriptionID, StorageUtil.clubID, this.productTypeID).subscribe((rs: any) => {
      this.loader.hide()
      this.cardText = rs;
    });
  }

  getClubSubscriptionPlans1() {
    this._service.getClubSubscriptionPlans(StorageUtil.clubID).subscribe((rs: any) => {
      this.subscriptionPlans = rs;
      this.hasPlan = rs.hasEvaluationPlan;
      this.isPlanAlreadyCancelled = this.subscriptionPlans.HasEvaluationPlanCancelled;

      this.store.dispatch({
        type: AppTypes.UpdateState,
        payload: {
          [AppFields.SubscriptionPlans]: rs
        }
      });
    });
  }

  applyDicsountCode(event) {
    if (!this.formCode.value.Code) {
      this._alertService.warn("Please enter valid Discount Ccode.");
      return;
    }

    event.target.innerHTML = 'Applying <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    var discountCode = this.formCode.value.Code;
    var originalAmount = this.selectedProgram.price;
    this.codeApplied = false;

    //Validate Code
    this._service.validateDiscountCode(discountCode, originalAmount).subscribe((rs: any) => {
      if (rs != null) {
        //console.log(rs);
        this.discountAmount = rs;
        if (this.discountAmount > 0) {
          this.totalAmount = originalAmount - this.discountAmount;
          this.codeApplied = true;
          this._alertService.success("Your Discount Code is Applied Successfully.");
        }
      }
      event.target.innerHTML = 'Apply Code';
      event.target.disabled = false;
    }, (error) => {
      //console.log(error.error);
      event.target.innerHTML = 'Apply Code';
      event.target.disabled = false;
      this._alertService.error(error.error);
    });
  }

  async onAddingCard(event) {
    //console.log("called onAddingCard()");
    event.target.innerHTML = 'Adding <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    const { token, error } = await stripe.createToken(this.card);
    if (error) {
      this.loader.hide();
      event.target.innerHTML = 'Add Card';
      event.target.disabled = false;
      if (error.code === 'card_declined' && error.type === 'card_error') {
        this._alertService.error('The credit card information is not valid');
      }
    } else {
      this.tokenData = token;
      //console.log(this.tokenData);
      this.isDefaultCard = 2;
      const obj = {
        UserID: StorageUtil.userID,
        StripeToken: token.id,
        StripeCardID: token.card.id,
        CardType: this.tokenData.card.brand,
        MaskedCCNum: 'xxxx-xxxx-xxxx-' + this.tokenData.card.last4,
        FullName: '',
        ExpDate: this.tokenData.card.exp_month + '/' + this.tokenData.card.exp_year,
        CVC: 0,
        IsDefault: 1,
        AddedBy: StorageUtil.userID
      };
      this._myTeamsService.addNewCard(obj).subscribe(
        () => {
          event.target.innerHTML = 'Add Card';
          event.target.disabled = false;
          this.loader.hide();
          this._alertService.success('New Card Added Successfully.');
          this.getCardListByUserID();
          this.card.clear();
        },
        (error) => {
          event.target.innerHTML = 'Add Card';
          event.target.disabled = false;
          this.loader.hide();
          this._alertService.error('We have a problem. Please try again.');
          // console.log(error);
          this.card.clear();
        }
      );
    }
  }

  onSubmit(event) {
    this.loader.show();

    event.target.innerHTML = 'Please Wait <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    const obj = {
      ClubID: StorageUtil.clubID,
      ClubName: this.clubDetails.name,
      ClubLogo: this.clubDetails.clublogo,
      TeamID: StorageUtil.teamId || 0,
      UserID: StorageUtil.userID,
      UserFirstName: this.userDetails.firstName,
      UserLastName: this.userDetails.lastName,
      UserEmail: this.userDetails.email,
      ProductPlanID: this.selectedProgram.productPlanID,
      UserCardID: this.userCardID,
      Recurring: this.selectedProgram.recurring,
      DiscountCode: this.formCode.value.Code,
      OriginalAmount: this.selectedProgram.price,
      DiscountAmount: this.discountAmount,
      AmountPaid: this.totalAmount > 0 ? this.totalAmount : this.selectedProgram.price,
      IPAddress: this.ipAddress,

      TGSRepUserID: this.selectedResUserID,
      TGSRepName: this.selectedFeedbackOpton == 'tgs' ? this.selectedRepresentativeName : null,
      TGSRepEmail: this.selectedResEmail,

      OtherClubName: this.selectedClubName,
      OtherClubContactName: this.selectedClubRepresentativeName,
      OtherName: this.selectedFeedbackOpton == 'other' ? this.selectedRepresentativeName : null,
      StripeToken: this.selectedCardData.stripeToken,
      StripeCardID: this.selectedCardData.stripeCardID,
      CardType: this.selectedCardData.cardType,
      MaskedCCNum: this.selectedCardData.maskedCCNum,
      ExpDate: this.selectedCardData.expDate,
      IsPremium: false,
      ProductType: this.productTypeID
    };

    //console.log("obj =>", obj);

    this._service.registerClubTeamToProductPlanSubscription(obj).subscribe(
      (rs: any) => {
        //console.log("rs =>", rs);
        if (rs && rs.data) {
          this._service.generatePDFAfterRegisterClubToCollegeProductPlan(rs.data, obj).subscribe();
        }

        event.target.innerHTML = 'Submit';
        event.target.disabled = false;
        this.loader.hide();
        this.closeSideOverlay();
        let url = "";
        if (this.productTypeID == 1) {
          url = 'CollegeRecruting';
        } else if (this.productTypeID == 2) {
          url = 'Evaluations';
        } else if (this.productTypeID == 3) {
          url = 'Video';
        } else if (this.productTypeID == 4) {
          url = 'HealthAndFitness';
        } else if (this.productTypeID == 11 || this.productTypeID == 5) {
          if (this.planList.filter(x => x.planTitle.includes("Complete")).length > 0) {
            url = 'TeamCompleteProduct';
          } else {
            url = 'TeamSidelineCheckin';
          }
        } else if (this.productTypeID == 6) {
          url = 'EmailCampaign';
        } else if (this.productTypeID == 7) {
          url = 'ClubMobileApp';
        }
        this.router.navigate(['/high-five-success/' + url]);
      },
      (error) => {
        event.target.innerHTML = 'Submit';
        event.target.disabled = false;
        this.loader.hide();
        console.log(error.error);
        this._alertService.error(error.error);
        //this._alertService.error('We have a problem. Please try again OR Contact to support.');
      }
    );
  }

  onCancelClick() {
    //Reset Discount if Applied
    this.codeApplied = false;
    this.discountAmount = 0;
    this.totalAmount = 0;
    this.formCode.reset();

    //Back to Options
    this.agreedToTerms = false;
    this.selectedFeedbackOpton = null;
    this.selectedResEmail = "";
    this.selectedResUserID = 0;
    this.isSelectedRepresentativeOther = false;
    this.selectedRepresentativeName = null;
    this.selectedClubName = null;
    this.selectedClubRepresentativeName = null;
    this.isProgramSelected = false;

    if (this.isTeamAccount) {
      this.closeSideOverlay();
    }
  }

  initCardNativeElement() {
    this.isAddNewCard = true;
    this.cardNativeElement();
    this.loader.show();
    setTimeout(() => {
      this.loader.hide();
      this.showAddNewCardButton = true;
    }, 1500);
  }

  getTGSRepresentativeList() {
    this._myTeamsService.getTGSRepresentativeList().subscribe((res: any) => {
      this.tgsRepresentativesOptions = res;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/subscription-fly-out/subscription-fly-out.component.ts